(() => {
  const css = `@media(max-width:767px){
    #tidio-chat-root{margin:0!important;bottom:calc(90px + env(safe-area-inset-bottom,0px))!important;right:12px!important;top:auto!important;max-height:calc(100dvh - 114px)!important;--bubble-size:48px!important}
    #tidio-chat-root:has(#button.chat-open){width:calc(100vw - 24px)!important;height:min(660px,calc(100dvh - 114px))!important;grid-template-rows:minmax(0,1fr) 48px!important}
    #tidio-chat-root:has(#button.chat-open) .chat{width:100%!important;height:100%!important}
    .widgetLabel{display:none!important}
  }`;
  function install(attempt = 0) {
    const host = document.getElementById('tidio-chat');
    if (!host) return;
    const root = host.shadowRoot;
    if (!root) {
      if (attempt < 10) setTimeout(() => install(attempt + 1), 500);
      return;
    }
    if (root.getElementById('hah-mobile-chat-style')) return;
    const style = document.createElement('style');
    style.id = 'hah-mobile-chat-style';
    style.textContent = css;
    root.append(style);
  }
  function watchPurchase(attempt = 0) {
    if (!document.body.classList.contains('template-product')) return;
    const purchase = document.querySelector('#new-form');
    if (!purchase) {
      if (attempt < 20) setTimeout(() => watchPurchase(attempt + 1), 500);
      return;
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        document.body.classList.toggle('hah-purchase-in-view', entry.isIntersecting);
      }).observe(purchase);
    }
  }
  watchPurchase();
  install();
  new MutationObserver(() => install()).observe(document.body, {childList: true});
})();
